import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	integrations: [],
	errorMessage: null,
	currentIntegration: {},
};

export default function integrationsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_INTEGRATIONS_SUCCESS:
			return Object.assign({}, state, {
				integrations: action.integrations,
			});
		case ActionTypes.LOAD_INTEGRATIONS_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.SELECT_INTEGRATION_SUCCESS:
			return Object.assign({}, state, {
				currentIntegration: action.integration,
			});
		case ActionTypes.RESET_CURRENT_INTEGRATION:
			return Object.assign({}, state, {
				currentIntegration: {},
			});
		default:
			return state;
	}
}
